import { env } from '@/lib/env'

const GENERIC_LANDING_API_ERROR = 'Não foi possível concluir. Tente de novo em instantes.'

let preferConfiguredApi = false

export function getLandingApiGenericErrorMessage(): string {
  return GENERIC_LANDING_API_ERROR
}

export function resetLandingApiBasePreferenceForTests(): void {
  preferConfiguredApi = false
}

export function rememberLandingApiProxyMiss(): void {
  const absolute = env.configuredApiBaseUrl.replace(/\/$/, '')
  if (absolute !== '') {
    preferConfiguredApi = true
  }
}

export function getLandingApiBaseUrls(): string[] {
  const relative = env.apiBaseUrl.replace(/\/$/, '')
  const absolute = env.configuredApiBaseUrl.replace(/\/$/, '')

  if (preferConfiguredApi && absolute !== '') {
    return [absolute]
  }

  const bases = [relative]
  if (absolute !== '' && absolute !== relative) {
    bases.push(absolute)
  }
  return bases
}

export function buildLandingApiUrl(endpoint: string, baseUrl: string): string {
  const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`
  return `${baseUrl.replace(/\/$/, '')}${path}`
}

function landingApiResponseLooksLikeJson(response: Response): boolean {
  const contentType = response.headers.get('content-type') ?? ''
  if (contentType === '') {
    return true
  }
  return contentType.toLowerCase().includes('application/json')
}

/** Cloudflare Pages devolve 405 (corpo vazio) ou HTML do SPA quando o Worker não faz proxy de /api. */
export function isLandingApiProxyMiss(response: Response): boolean {
  if (response.status === 405) {
    return true
  }

  return !landingApiResponseLooksLikeJson(response)
}

export function canReplayLandingRequestBody(body: BodyInit | null | undefined): boolean {
  if (body == null) {
    return true
  }
  if (typeof body === 'string') {
    return true
  }
  if (typeof FormData !== 'undefined' && body instanceof FormData) {
    return true
  }
  if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
    return true
  }
  if (typeof Blob !== 'undefined' && body instanceof Blob) {
    return true
  }
  if (typeof ArrayBuffer !== 'undefined' && body instanceof ArrayBuffer) {
    return true
  }
  return ArrayBuffer.isView(body)
}
